import flexibleIcon from "../assets/paymentplan/flexible.svg";
import moderateIcon from "../assets/paymentplan/moderate.svg";
import secureIcon from "../assets/paymentplan/secure.svg";

/**
 * Returns the SVG asset corresponding to a given payment plan name.
 * @param {string} paymentPlan
 * @returns {string} SVG icon path
 */
export const getPaymentPlanIcon = (paymentPlan) => {
  const plan = String(paymentPlan || "").toLowerCase();
  if (plan.includes("direct")) {
    return flexibleIcon;
  }
  if (plan.includes("moderate")) {
    return moderateIcon;
  }
  return secureIcon;
};

/**
 * Returns standardized payment plan details with label and SVG icon.
 * UI mapping:
 * - DIRECT  -> "Flexible Plan" (flexibleIcon)
 * - MODERATE -> "Moderate Plan" (moderateIcon)
 * - FLEXIBLE -> "Secure Plan" (secureIcon)
 * @param {string} paymentPlan
 * @returns {{ id: string, label: string, icon: string }}
 */
export const getPaymentPlanDetails = (paymentPlan, roleType) => {
  const plan = String(paymentPlan || "").toLowerCase();
  const role = String(roleType || "").toLowerCase();
  if (plan.includes("direct")) {
    return {
      id: "direct",
      label: "Flexible Plan",
      icon: flexibleIcon,
      description: "Booking confirmed with 10% advance via GoPratle. Remainder settled directly.",
    };
  }
  if (plan.includes("moderate")) {
    return {
      id: "moderate",
      label: "Moderate Plan",
      icon: moderateIcon,
      description: "Pay 50% through GoPratle, with the remaining 50% paid directly to the professional.",
    };
  }
  return {
    id: "flexible",
    label: "Secure Plan",
    icon: secureIcon,
    description: "Payments and payouts through GoPratle, with milestone-based settlements where applicable.",
  };
};
